import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// Interface
import { IServerSide } from '@/shared/components/general/table-generic/interface/table-generic.interface';
import { IDataPagination } from '@/interface/general/IPagination';
import { HttpGeneric } from '@/models/class/httpGeneric';
import { KeyValueArrayGeneric } from '@/interface/general/params.interface';
import { PermissionsService } from '@/shared/service/Permissions.service';
import {
  IResponseApiGeneric,
  IResponseApiGenericSS,
} from '@/interface/general/IResponseApi';
import { IUserPermissions } from '@/shared/interfaces/Permissions.interface';
import { IConfiguracionSistema } from '../../../../../pages/radicacion/flujo-doc-procesos/interfaces/flujo-doc-procesos.interface';
import { IFormDataTimelineDocumento } from '../interface/dinamic-form.interface';

@Injectable({
  providedIn: 'root',
})
export class GeneralService<T> extends HttpGeneric<string | number> {
  // Data para la Tablet Generic
  dataTableGenericSubject$ = new Subject<IDataPagination<IServerSide>>();

  //URL
  public urlGetAll = 'DocumentosRelacionados/GetAll';
  private urlPutUpdate = 'DocumentosRelacionados/Update';
  private urlPostCreate = 'DocumentosRelacionados/Create';
  private urlGetById = 'DocumentosRelacionados/GetById?Id=';
  private urlDelete = 'DocumentosRelacionados/Delete?idEntity=';
  private urlGetInitialData = 'DocumentosRelacionados/GetInitialConsultaData';

  private urlPDFsByPaquete = 'Files/GetPDFsByPaquete';
  private urlPDFByArchivo = 'Files/GetFileByfdArchivo';

  permissonService = inject(PermissionsService);

  /**
   * Metodo para crear el registro
   * @param data
   * @returns respuesta del backend
   */
  post(
    data: IFormDataTimelineDocumento
  ): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Post<IResponseApiGeneric<T>>(
      data,
      this.urlPostCreate
    );
  }

  /**
   * Actualizamos
   * @param data Parametros a actualizar
   * @returns respuesta
   */
  Put(data: IFormDataTimelineDocumento): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Put<IResponseApiGeneric<T>>(
      data,
      this.urlPutUpdate
    );
  }

  /**
   * Eliminamos un registros
   * @param Id Id a eliminar
   * @returns respuesta
   */
  delete(Id: number) {
    return this.httpService.Delete<IResponseApiGeneric<T>>(
      this.urlDelete + `${Id}`
    );
  }

  /**
   * Obtenemos los parametros iniciales
   * @returns
   */
  getInitialParameters$(): Observable<
    IResponseApiGeneric<IConfiguracionSistema>
  > {
    return this.httpService.Get<IResponseApiGeneric<IConfiguracionSistema>>(
      this.urlGetInitialData
    );
  }

  
  setPermises(
    programasPermisosList: IUserPermissions,
    nameVista: string,
    arrayBtnPermitidos: string[]
  ) {
    // 1. Establecer permisos y botones permitidos
    this.permissonService.setActiveProgramAndButtons(
      nameVista,
      arrayBtnPermitidos
    );

    // 2. Establecer programa activo
    this.permissonService.setPermissionsForProgram(programasPermisosList);
  }

  //buscar id
  getQueryById(id: number): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Get<IResponseApiGeneric<T>>(
      `${this.urlGetById}${id}`
    );
  }

  
  getWitchParams(
    datos: KeyValueArrayGeneric<string | number>
  ): Observable<IResponseApiGenericSS<IFormDataTimelineDocumento  >> {
    const params = this.dynamicParams(datos);
    // El any se remplaza por la interface de la estructura que te devuelve la BD
    // ej: return this.httpService.GetParams<IResponseListFilesParams>
    return this.httpService.GetParams<
      IResponseApiGenericSS<IFormDataTimelineDocumento>
    >(this.urlGetInitialData, params);
  }

  getWitchParamsAndUrl(
    datos: KeyValueArrayGeneric<string | number>,
    url: string
  ): Observable<IResponseApiGenericSS<IFormDataTimelineDocumento>> {
    const params = this.dynamicParams(datos);
    // El any se remplaza por la interface de la estructura que te devuelve la BD
    // ej: return this.httpService.GetParams<IResponseListFilesParams>
    return this.httpService.GetParams<
      IResponseApiGenericSS<IFormDataTimelineDocumento>
    >(url, params);
  }

  //buscar id
  getByUrlComplete(url: string): Observable<IResponseApiGeneric<T>> {
    return this.httpService.GetWithUrlComplete<IResponseApiGeneric<T>>(url);
  }

  

  //#region ESte es para la botonera de Comparar
  getPDFsByPaquete(
    IdfdArchivo: string | number,
    RetornarBase64 = true
  ): Observable<IResponseApiGenericSS<{ fileBase64: string }>> {
    const params = this.dynamicParams([
      { key: 'IdfdArchivo', value: IdfdArchivo },
      { key: 'RetornarBase64', value: RetornarBase64 ? 'true' : 'false' },
    ]);

    return this.httpService.GetParams<
      IResponseApiGenericSS<{ fileBase64: string }>
    >(this.urlPDFsByPaquete, params);
  }

  getPDFByArchivo(
    IdfdArchivo: string | number,
    RetornarBase64 = true
  ): Observable<IResponseApiGenericSS<{ fileBase64: string }>> {
    const params = this.dynamicParams([
      { key: 'IdfdArchivo', value: IdfdArchivo },
      { key: 'RetornarBase64', value: RetornarBase64 ? 'true' : 'false' },
    ]);

    return this.httpService.GetParams<
      IResponseApiGenericSS<{ fileBase64: string }>
    >(this.urlPDFByArchivo, params);
  }
  //#endregion
}
